/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2022-12-07 09:53:03
 * @Description: 
 */
import { Tooltip } from "antd";
import clsx from "clsx";
import { autorun } from "mobx";
import React from "react"
import FTAnalytic from "src/analyze/FTAnalytic";
import { IconHDNew } from "src/assets";
import FTCanvasStore from "src/store/FTCanvasStore";
import FTImageStore from "src/store/FTImageStore";
import FTUserStore from "src/store/FTUserStore";
import { FTSaveLocalData } from "src/utils";
import FTLang from "src/utils/FTLang";
import "./index.scss"
interface Iprops {
  needToolTip: boolean;
}
export default function FTimageHD(props: Iprops) {
  let { needToolTip } = props
  let [active, setActive] = React.useState(false)

  React.useEffect(() => {
    autorun(() => {
      setActive(FTImageStore.imageHD)
    })
  }, [])
  const handleImageHD = (isSpecail=false) => {
    FTAnalytic.addAnalytic({
      type: 'ev',
      analyticType: "sa",
      action: 'fotor_web$click_up$goart_project_effects',
      label: {
        resource_id: "HD",
        resource_name: "HD",
      }
    })
    if(!FTImageStore.imageHD) {
      if(!FTUserStore.userInfo) {
        // 登录
      FTUserStore.showLogin({
        isSignIn: false,
        options: {
          position: "goart_download_fullsize"
        }, 
        isShowScenses: true,
        otherParam: {
          scenesId: "010",
          width: FTImageStore.currentSize.width,
          height: FTImageStore.currentSize.height,
          imgSrc: FTCanvasStore.canvas!.toDataURL("image/jpeg")
        },
        callback: () => {
          handleImageHD(true)
        }
      })
        return
      }
      if(!FTUserStore.isVip) {
        // 升级
        FTUserStore.showPaymnet({
          vipType: "vip",
          position: "goart_download_hd",
          otherParam: {
            scenesId: "012"
          },
          callback: () => {
            handleImageHD(true)
          }
        })
        return
      }
    }
    if(isSpecail){
      return
    }
    FTImageStore.imageHD = !FTImageStore.imageHD
  }
  return <div
    className={clsx("ai_image_HD", active && "active")}
    onClick={()=>{handleImageHD()}}
  >
    {needToolTip ? <Tooltip key="image_HD_tip" placement={"left"} color="#FFFFFF" overlayClassName="ai_image_common_operate_tip" title={FTLang._(active ? "goart_HD_close_tip" : "goart_HD_open_tip")}>
        <div className="ai_image_common">
          <IconHDNew />
        </div>
      </Tooltip> : <IconHDNew key="image_HD" />}
  </div>
}